export function filterCustomScripts() {
  if(document.getElementById('product-filter') && document.getElementById('filter-button')){
    var filterCloser = document.getElementById('close-filter');
    var filterWrapper = document.getElementById('product-filter');
    var filterButton = document.getElementById('filter-button');
    var clickFlag = false;

    filterCloser.addEventListener('click', function(){
      if(!filterWrapper.classList.contains('closed')){
        filterWrapper.classList.add('closed');
      }
    });
    document.addEventListener('click',function(event){
        if(!clickFlag){
          clickFlag = true;

          if (filterButton.id === event.target.id ||
            filterButton.id === event.target.parentNode.id ||
            filterWrapper.id === event.target.id ||
            filterWrapper.id === event.target.parentNode.id) {
              if (filterWrapper.classList.contains('closed')) {
                filterWrapper.classList.remove('hide-filter');
                filterWrapper.classList.remove('closed');
              } else {
                filterWrapper.classList.add('closed');
                setTimeout(function(){
                  filterWrapper.classList.add('hide-filter');
                },500);
              }
          }

          setTimeout(function(){
            clickFlag = false;
          },500);
        }
    });
  }
}
